// extracted by mini-css-extract-plugin
export default {"list":"intuition_list__AI02-"};